// Indented JSON as coloured tokens, for the example panes. The app's body viewer (CodeBodyViewer.vue) is not
// used there: it draws a toolbar and line numbers, and it colours only a body that parses as one document,
// while an example shows several documents one under another.

export type JsonTokenKind = 'property' | 'string' | 'literal' | 'punctuation' | 'plain'

export interface JsonToken {
  text: string
  kind: JsonTokenKind
}

// Group 1 is a quoted string and group 2 the colon after it, which makes it a property name.
// Group 3 is a number, true, false or null. Group 4 is a brace, a bracket or a comma.
const TOKEN = /("(?:[^"\\]|\\.)*")(\s*:)?|(-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?|true|false|null)|([{}\[\],])/g

export function jsonTokens(value: unknown): JsonToken[] {
  const text = JSON.stringify(value, null, 2)
  const tokens: JsonToken[] = []
  let end = 0

  for (const match of text.matchAll(TOKEN)) {
    const [whole, quoted, colon, literal, punctuation] = match
    const start = match.index
    // Whatever sits between two tokens is indentation or a line break.
    if (start > end) tokens.push({ text: text.slice(end, start), kind: 'plain' })

    if (quoted && colon) {
      tokens.push({ text: quoted, kind: 'property' })
      tokens.push({ text: colon, kind: 'punctuation' })
    } else if (quoted) {
      tokens.push({ text: quoted, kind: 'string' })
    } else if (literal) {
      tokens.push({ text: literal, kind: 'literal' })
    } else {
      tokens.push({ text: punctuation, kind: 'punctuation' })
    }
    end = start + whole.length
  }

  if (end < text.length) tokens.push({ text: text.slice(end), kind: 'plain' })
  return tokens
}
